import { Moment } from 'moment';
import { ReactElement } from 'react';
import { TableColumn } from './TableHeaders';

export const AssessmentsHeaderMobile = (fm) => {
  return [
    {
      label: fm({ id: 'assessment.table.subheader3' }),
      key: 'competence',
    },
  ] as TableColumn<AssessmentRow>[];
};

export const AssessmentsHeader = (fm) => {
  return [
    {
      label: fm({ id: 'assessment.table.subheader1' }),
      key: 'completedDate',
      sortFunction: (a, b) => {
        return a.completedDateValue.diff(b.completedDateValue);
      },
    },
    {
      label: fm({ id: 'assessment.table.subheader2' }),
      key: 'assessor',
    },
    {
      label: fm({ id: 'assessment.table.subheader3' }),
      key: 'competence',
    },
    {
      label: fm({ id: 'common.table.vessel' }),
      key: 'vessel',
      sortKey: 'vesselValue',
    },
    {
      label: fm({ id: 'common.table.periode' }),
      key: 'period',
      sortFunction: (a, b) => {
        const startDiff = a.periodStart.diff(b.periodStart);
        if (startDiff !== 0) return startDiff;
        return a.periodEnd.diff(b.periodEnd);
      },
    },
  ] as TableColumn<AssessmentRow>[];
};

export interface AssessmentRow {
  completedDate: string;
  completedDateValue: Moment;
  assessor: string;
  competence: string;
  vessel: ReactElement | string;
  vesselValue: string;
  period: string;
  periodStart: Moment;
  periodEnd: Moment;
}
